module.exports = __webpack_public_path__ + "img/banner2-3@1x.71893f9d.jpg";